import { useState } from "react";
import BarcodeReader from "react-barcode-reader";
import toast from "react-hot-toast";
import useApiMutation from "../../hooks/tanstack/useApiMutation";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { setAttendRefetch } from "../../store/reducers/attendRefetchSlice";

const QrScan = () => {
    const [lastScan, setLastScan] = useState('');
    const dispatch = useDispatch<AppDispatch>();

    const { mutateAsync: sendDataToAPI } = useApiMutation<any, any, any>({
        url: "attendance-set",
        method: "post",
        options: {
            onSuccess: () => {
                dispatch(setAttendRefetch(true));
                toast.success("Ma'lumot muvaffaqiyatli yuborildi!");
            },
            onError: () => {
                toast.error("Ma'lumotni yuborishda xatolik yuz berdi!");
            },
        },
    });

    const handleScan = async (scanned: string) => {
        const trimmed = scanned.trim();

        if (!trimmed) {
            toast.error("Scan qilingan ma'lumot bo'sh!");
            return;
        }

        const [groupId, studentId, lessonId] = trimmed.split('/');

        if (!groupId || !studentId || !lessonId) {
            toast.error("QR kod formati noto‘g‘ri!");
            return;
        }

        setLastScan(trimmed);

        await sendDataToAPI({
            groupId,
            students: [
                {
                    studentId,
                    state: "attended",
                },
            ],
            lessonId,
        });
    };

    const handleError = (err: any) => {
        if (err && typeof err !== 'string') {
            console.error("QR skan xatosi:", err);
            toast.error("Skaner xatolikka uchradi!");
        }
    };


    return (
        <div>
            <BarcodeReader
                onScan={handleScan}
                onError={handleError}
            />
            {/* <h3>Oxirgi o'qilgan QR Code:</h3>
            <p>{lastScan || "Skaner ma'lumot kutilmoqda..."}</p> */}
        </div>
    );
};

export default QrScan;
